import Chips from '@/common/components/base/chips/Chips';
import ModalInput from '@/common/components/base/input/modalInput/ModalInput';
import searchAttachment from '@/common/components/base/input/textInput/attachments/searchAttachment';
import { FileStateType } from '@/common/types/Files.type';
import { SelectionOptionsType } from '@/common/types/SelectionOptions.type';
import SimpleFilterForm from '@/modules/FileList/components/listFilterSection/simpleFilter/SimpleFilterForm';
import AdvanceFilterModals from '@/modules/FileList/components/modals/advanceFilterModals/AdvanceFilterModals';
import { ChipDataType } from '@/modules/FileList/hooks/useFilterChips';
import useFilterQueryParams from '@/modules/FileList/hooks/useFilterQueryParams';
import { MyFilesListQueryKey } from '@/modules/FileList/queries/myFilesList/myFilesListQuery.type';
import { FormProvider, useForm } from 'react-hook-form';
import { css } from 'styled-system/css';
import { Box } from 'styled-system/jsx';

const ListFilter = ({
  filterChipsList,
  hasDateOrFileState,
}: {
  filterChipsList: ChipDataType[];
  hasDateOrFileState?: boolean;
}) => {
  const methods = useForm();
  const { filterQueryParams, SpliceArrayQueryParams } = useFilterQueryParams();
  return (
    <FormProvider {...methods}>
      <Box
        display="flex"
        gap="0.5rem"
        justifyContent={'space-between'}
        alignItems={'center'}
      >
        <ModalInput
          name="search"
          inputProps={{ className: css({ width: '100%' }), width: '100%' }}
          onChange={() => {}}
          placeholder="جستجو شناسه پرونده ، شماره تلفن ، پلاک"
          endAttachments={[searchAttachment({ shouldRender: true })]}
        >
          {(onClose) => (
            <SimpleFilterForm
              isInNewDocumentPage={!hasDateOrFileState}
              onCloseModal={onClose}
            />
          )}
        </ModalInput>
        <AdvanceFilterModals hasDateOrFileState={hasDateOrFileState} />
      </Box>
      <Box mb="12px" width={'100%'} overflow={'auto'}>
        <Box mb="12px" display={'flex'} textWrap={'nowrap'}>
          {filterChipsList?.map(
            (item) =>
              item?.renderCondition &&
              (item?.multiple ? (
                (item?.value as SelectionOptionsType<string | number>[])?.map(
                  (singleItem, index) => (
                    <Chips
                      key={singleItem.label}
                      text={singleItem.label}
                      onClick={() => {
                        SpliceArrayQueryParams({
                          removedItem: item.name as MyFilesListQueryKey,
                          index: index,
                        });
                      }}
                    />
                  ),
                )
              ) : item.selectionOptions ? (
                <Chips
                  key={item.name}
                  text={
                    (item?.value as { label: string; value: FileStateType })
                      ?.label
                  }
                  onClick={() => {
                    filterQueryParams({
                      removedItem: item.name as MyFilesListQueryKey,
                    });
                  }}
                />
              ) : (
                <Chips
                  key={item.name}
                  text={item?.value as string}
                  onClick={() => {
                    filterQueryParams({
                      removedItem: item.name as MyFilesListQueryKey,
                    });
                  }}
                />
              )),
          )}
        </Box>
      </Box>
    </FormProvider>
  );
};

export default ListFilter;
